
import WebFont from 'webfontloader'

const options = {"google":{"families":["Montserrat:100,300,400,500,700,900","Catamaran:100,300,400,500,700,900","Roboto:100,300,400,500,700,900&display=swap"]}}

WebFont.load(options)
